import React from 'react';

// 기타 카테고리 (점 세 개)
const EtcIcon = ({ width = 24, height = 24, color = '#0F7F85' }) => (
  <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z" stroke={color} strokeWidth="2" />
    <path d="M6.5 11H6.51M11 11H11.01M15.5 11H15.51" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export default EtcIcon;
